<template>
  <div class="doctorInfo">
    <div class="doctor-info-bar">
      <div class="head-name">
        <img :src="doc_info.phead" alt />
        <p>{{ doc_info.pname }}</p>
      </div>
      <div class="doctot-text">{{ doc_info.pinfo }}</div>
    </div>
    <div class="close-doctor-info" @click="updateMessage"></div>

    <div class="add-video" @click="add_videeo">添加视频</div>
    <div class="doctor-video-info">
      <ul>
        <li v-for="(item,i) in v_list" :key="i" v-show="item.vcurl">
          <div class="info-li-content">
            <div class="v-cover-img">
              <video width="100" height="60" controls :src="item.vcurl + '#t=1'">您的浏览器不支持视频播放</video>
              <div class="video-name">
                <div>视频名:{{item.vname}}</div>
                <div>视频简介:{{item.vtext}}</div>
              </div>
            </div>
            <div class="li-ispay">
              <div v-if="item.ispay == 0">免费观看</div>
              <div v-else>价格: <span class="price-text">{{item.vprice}}</span> 元</div>
              <div v-if="item.ispay == 1" @click="is_stop_pay(item)">停止收费</div>
              <div v-else  @click="is_stop_pay(item)">开始收费</div>
            </div>
            <div class="play-video-url">
              <div @click="chageUrl(item)">切换播放链接</div>
              <div @click="g_discount_code(item)">生成优惠码</div>
            </div>
            <div class="video-preview-del">
              <div @click="begin_play(item)">预览</div>
              <div @click="del_video(item)">删除</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 添加视频 -->
    <Overlay :show="isShow_add">
      <div class="add-v-content">
        <div class="add-v-title">视频上传</div>
        <div class="close-file-change" @click="isShow_add = false"></div>
        <div class="add-v-file">
          <div>选择视频:</div>
          <Uploader
            max-count="1"
            v-model="v_list[0].vurl"
            accept="video/*"
            style="height: 100px; width: 100px"
            v-if="v_list[0].vurl == ''"
          />
          <div v-if="v_list[0].vurl != ''" class="video-preview">
            <video
              width="100"
              height="100"
              controls
              :src="v_list[0].vurl[0].objectUrl + '#t=1'"
            >
              您的浏览器不支持视频播放
            </video>
          </div>
        </div>
        <div class="add-v-name">
          <div>视屏名称:</div>
          <Field
            v-model="v_list[0].vname"
            placeholder="请输入视屏名称"
            maxlength="20"
            type="text"
          />
        </div>

        <div class="add-v-jj">
          <div>视屏简介:</div>
          <Field
            v-model="v_list[0].vtext"
            placeholder="请输入简介"
            maxlength="20"
            type="text"
          />
        </div>
        <div class="add-is-pay">
          <div>是否付费:</div>
          <Switch v-model="v_list[0].v_isPay" />
        </div>
        <div class="add-v-price" v-if="v_list[0].v_isPay">
          <div>视屏价格:</div>
          <Field
            v-model="v_list[0].v_price"
            placeholder="请输入视频价格(以元计算)"
            maxlength="20"
            type="number"
          />
        </div>
        <Button type="success" size="large" class="sub-v-btn" @click="update_video">上传</Button>
      </div>
    </Overlay>

    <Overlay :show="plarurl != ''">
        <div class="player-content">
          <div>
            <video controls ref="videoRef">
              <source :src="plarurl+'#t=1'" type="video/mp4">
              <source :src="plarurl+'#t=1'" type="video/webm">
              您的浏览器不支持 HTML5 视频标签。
            </video> 
            <div class="close-player">
              <Icon name="cross" @click.stop="close_play_status"  class="close-player-icon"  color="#fff"/>
            </div>
          </div>
        </div>
    </Overlay>

  </div>
</template>
<script setup>
import { put_file, addVideo, getVideo, delVideo, modifyVideo, createCode } from '@/api/index'
import { computed, getCurrentInstance, onMounted, onBeforeMount, ref, nextTick } from "vue";
import { showLoadingToast, closeToast, showToast, Field, Uploader, Switch, Button, Overlay, Icon } from "vant";

import { copyText } from '@/utils/global'
import gsap from "gsap";
const props = defineProps({
  doc_info: Object,
  isShowInfo: Boolean,
});
const emit = defineEmits([["update-isShowInfo"]]);
const videoRef = ref(null);
const v_list = ref([]); //视频数组
const add_clock = ref(false); //添加锁
const isShow_add = ref(false);
const plarurl = ref('')
onMounted( async () => {
  showLoadingToast({
    message: "加载中...",
    duration: 0,
  });
  getdoctorInfo()
  setTimeout(() => {
    closeToast();
  }, 500);
});
// 获取医师视频信息
const getdoctorInfo = async () => {
  let res = await getVideo({pid:props.doc_info.pid})
  v_list.value = res.data
  console.log(res.data)
}
// 方法：触发事件，将新值传递给父组件
const updateMessage = () => {
  emit("update-isShowInfo", false);
};
// 添加视频
const add_videeo = () => {
  if (add_clock.value) {
    showToast("请勿连续点击");
    return;
  }
  add_clock.value = true;
  setTimeout(() => {
    add_clock.value = false;
  }, 1500);
  let list = v_list.value;
  gsap.to(".add-video", { scale: 0.9, duration: 0.1, yoyo: 1, repeat: 1 });
  let add_list = {
    vname: "",
    vurl: [],
    vtext: "",
    v_isPay: false,
    v_price: 0,
  };
  if (v_list.value.length > 0) {
    let { vname } = v_list.value[0];
    if (vname != "") {
      list.unshift(add_list);
    }
  } else {
    list.unshift(add_list);
  }
  v_list.value = list;
  isShow_add.value = true;
};
// 上传视频
const update_video = async () =>{
  let { vname, vtext, v_isPay, v_price, vurl} = v_list.value[0]
  if(vurl.length == 0){
    showToast('未选择视频...')
    return
  }
  if(vname == ''){
    showToast('视频名称不能为空')
    return
  }
  if(vtext == ''){
    showToast('视频简介不能为空')
    return
  }
  if(v_isPay && v_price<=0){
    showToast('价格输入不合法')
    return
  }
  showLoadingToast({
      message: '正在上传，请勿退出！！！',
      duration:0,
  })
  let v_file = v_list.value[0].vurl[0].file
  const formData = new FormData();
  formData.append('files[]', v_file);
  const response = await put_file(formData);
  if(response.data == 501){
    closeToast()
    showToast('视频上传失败')
    return 
  }
  let subData = {
    pid:props.doc_info.pid,
    vname,
    vtext,
    ispay:v_isPay ? 1 : 0,
    vprice:v_price,
    vfileurl: response.data.FileUrl,
    vcurl: response.data.OutputUrl,
  }
  const add_res = await addVideo(subData) 
  isShow_add.value = false
  setTimeout(()=>{
    v_list.value = []
    getdoctorInfo()
  },200)
  closeToast()
}
// 修改计费
const is_stop_pay = async (item) => {
  if(item.ispay == 1){
    const isConfirmed = confirm("确定要停止计费吗？");
    if(isConfirmed){
      // 停止计费
      await modifyVideo({ispay:0,vprice:0,vid:item.vid})
      getdoctorInfo()
    }
  }else{
    const videoPrice = prompt("请输入视频价格(以元为单位)");
    if (videoPrice && videoPrice > 0) {
      // 停止计费
      await modifyVideo({ispay:1,vprice:videoPrice,vid:item.vid})
      getdoctorInfo()
    }
  }
}
// 切换播放链接
const chageUrl = async (e) =>{
  // 0: 编码视频 1:源码视频
  let text = '当前播放链接为编码后的视频链接,是否切换为源码链接'
  if( e.isoriginal == 1 ){
    text =  '当前播放链接为源码链接,是否切换为编码后的视频链接'
  }
  let val = e.isoriginal;
  const isConfirmed = confirm(text); 
  if( isConfirmed ){
    val = val == 0 ? 1 : 0
    console.log(val)
    await modifyVideo({isoriginal:val,vid:e.vid})
    getdoctorInfo()
  }
}
// 删除视频
const del_video = async(e) => {
  const isConfirmed = confirm('确认删除该视频吗，删除后将无法恢复！'); 
  if( isConfirmed ){
    await delVideo({vid:e.vid})
    getdoctorInfo()
  }
}
// 关闭预览
const close_play_status = () => {
  if (videoRef.value) {
    videoRef.value.pause(); // 先暂停视频
    videoRef.value.src = "";
    plarurl.value = ""; // 清空响应式数据
    // if (videoRef.value) {
    //   videoRef.value.reset(); // 重置播放器（如果有这个方法）
    // }
  }
}
// 开启预览
const begin_play = (item) => {
  plarurl.value = item.isoriginal == 0 ? item.vcurl : item.vfileurl;
  console.log(plarurl.value)
  nextTick(() => {
    if (plarurl.value) {
      videoRef.value.src = plarurl.value
      videoRef.value.load(); // 重新加载视频
      videoRef.value.play().catch(error => {
        console.error("播放失败:", error);
      });
    }
  });
}
// 生成优惠码
const g_discount_code =async (e) =>{
  if(e.ispay == 0){
    showToast('该视频为免费视频')
    return
  }
  
  showLoadingToast({
    message: "生成中...",
    duration: 0,
  });
  let res = await createCode({vid:e.vid,vname:e.vname})
  setTimeout(()=>{
    closeToast()
    let { vname, dcode } = res.data
    if(res.data.dcode){
      copyText(vname,dcode)
    }
    else{
      showToast('生成失败,请重试')
    }
  },1500)
}
</script>
<style lang="less">
.doctorInfo {
  width: 90%;
  height: 95%;
  margin: 0 auto;
  margin-top: 12px;
  border-radius: 15px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.8);
  position: relative;
  padding: 25px;
  overflow: hidden;
  padding-bottom: 20px;
}
.close-doctor-info {
  width: 15px;
  height: 15px;
  background: url("@/assets/imgs/nzsz_gb_icon.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 12px;
  top: 12px;
}
.add-video {
  width: 300px;
  font-size: 15px;
  text-align: center;
  margin: 0 auto;
  background: rgba(22, 22, 245, 0.3);
  padding: 5px 0px;
  border-radius: 17px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.8);
  cursor: pointer;
  margin-top: 12px;
  margin-bottom: 25px;
}
.head-name {
  max-width: 100px;
}
.doctor-info-bar {
  height: 100px;
  display: flex;
  align-items: center !important;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding-bottom: 25px;
}
.head-name img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
}
.head-name p {
  font-size: 15px;
  text-align: center;
}
.doctot-text {
  margin-left: 35px;
  height: 55px;
  font-size: 12px;
  color: #727272;
  margin-right: 55px;
}
.add-v-content {
  margin-top: 15px;
  background: #ddd;
  width: 400px;
  margin: 0 auto;
  margin-top: 15px 22px;
  padding: 15px;
  border-radius: 15px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.8);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .add-v-title {
    font-size: 22px;
    text-align: center;
    border-bottom: 1px solid #fff;
    padding-bottom: 25px;
    margin-bottom: 25px;
  }
}
.add-v-content .van-uploader__upload {
  width: 100px !important;
  height: 100px !important;
  border-radius: 10px;
  border: 1px solid rgba(22, 22, 245, 0.3);
}
.add-v-jj,
.add-v-price,
.add-v-name,
.add-is-pay {
  display: flex;
  align-items: center;
  margin-top: 15px;
  > div {
    font-size: 19px;
    white-space: nowrap;
    border-radius: 15px;
    margin-right: 15px;
  }
}
.add-v-file {
  border-radius: 10px;
  display: flex;
}
.add-v-file > div {
  font-size: 19px;
  white-space: nowrap;
  margin-right: 15px;
}
.video-preview video {
  object-fit: cover;
  border: 1px solid rgba(22, 22, 245, 0.3);
  border-radius: 15px;
}
.close-file-change {
  width: 15px;
  height: 15px;
  background: url("@/assets/imgs/nzsz_gb_icon.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 12px;
  top: 12px;
}
.update-btn {
  font-size: 15px;
  border: 1px solid rgba(22, 22, 245, 0.3);
  border-radius: 15px;
  margin: 0px 22px;
  white-space: nowrap;
  /* background: red; */
  background: rgba(22, 22, 245, 0.3);
  color: #fff;
  padding: 5px 22px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.8);
}
.video-preview video::-webkit-media-controls {
  display: none !important;
}
/* 或者，更精确地只隐藏进度条和播放按钮 */
.video-preview video::-webkit-media-controls-timeline {
  display: none !important;
}
.video-preview video::-webkit-media-controls-play-button {
  display: none !important;
}

.sub-v-btn {
  margin-top: 30px;
  font-size: 20px;
}
.icon-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 18px;
}

.icon-wrapper .van-icon-success {
  line-height: 32px;
  color: var(--van-blue);
}

.icon-wrapper .van-icon-cross {
  line-height: 32px;
  color: var(--van-gray-5);
}

.doctor-video-info{
  height: 550px;
  overflow: auto;
  padding: 8px;
  border-radius: 8px;
  video{
    border-radius: 8px;
  }
  li{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),-5px -5px 10px rgba(0, 0, 0, 0.1);
    padding: 8px 8px 0px 8px;
    background: #ddd;
    border-radius: 8px;
    margin-bottom: 20px;
  }
}
.v-cover-img{
  display: flex;
  align-items: center;
  padding-bottom: 8px;
}
.v-cover-img video::-webkit-media-controls {
  display: none !important;
}
.v-cover-img video::-webkit-media-controls-timeline {
  display: none !important;
}
.v-cover-img video::-webkit-media-controls-play-button {
  display: none !important;
}
.info-li-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.video-name{
  font-size: 15px;
  max-width: 500px;
  margin-left: 19px;
}
.li-ispay{
  font-size: 15px;
  margin-left: 19px;
  white-space: nowrap;
  span{
    color: red;
  }
  >div:last-of-type{
    cursor: pointer;
    color: blue;
    text-decoration: underline; 
  }
}
.play-video-url{
  font-size: 15px;
  white-space: nowrap;
  margin-left: 30px;
  >div{
    cursor: pointer;
    color: blue;
    text-decoration: underline; 
  }
}
.video-preview-del{
    font-size: 15px;
    margin-left: 30px;
    white-space: nowrap;
    cursor: pointer;
    color: blue;
    text-decoration: underline; 
}
.player-content{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  >div{
    width: 80%;
    height: 90%;
    background: black;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    video{
      width: 100%;
      height: 98%;
      object-fit: contain;
      border-radius: 20px;
    }
  }
}
.close-player-icon{
  position: absolute;
  top: 15px;
  right: 10px;
  
              font-size: 150px;
}

.close-player{
  width: 20px;
  height: 20px;
  position: absolute;
  top: 15px;
  right: 10px;
}
.close-player-icon{
  color: #dddddd;
  font-size: 20px;
  top: 0 !important;
  left: 0 !important;
}
</style>